import type { IFieldDefinition, IModuleDefinition, IRecordTypeDefinition, IRelatedModule } from '@platform/core/types';
import { relatedKeyOf } from './general/relatedKeyOf';

/** Поле з умовою показу пакета, якщо сервер її не віддав. */
const withVisibility = (field: IFieldDefinition, own: IRecordTypeDefinition): IFieldDefinition => {
  if (field.visibleWhen) return field;
  const visibleWhen = own.fields.find((f) => f.key === field.key)?.visibleWhen;
  return visibleWhen ? { ...field, visibleWhen } : field;
};

/** Секція «Пов’язані записи» з фільтром пакета (та сама пара модуль + підпис), якщо сервер його не віддав. */
const withFilter = (related: IRelatedModule, own: IRecordTypeDefinition): IRelatedModule => {
  if (related.filter) return related;
  const filter = own.related.find((r) => relatedKeyOf(r) === relatedKeyOf(related))?.filter;
  return filter ? { ...related, filter } : related;
};

/**
 * Визначення модуля для сторінки запису: серверне (авторитетне) з ознаками етапу 4, яких сервер ще не віддає (API старішої збірки), —
 * з визначення пакета модуля: підтаблиця типу (`subTable`), умови показу полів (`visibleWhen`) і фільтри секцій «Пов’язані записи»
 * (`related[].filter`). Те, що сервер віддає, не змінюється. Чиста функція.
 */
export function withPackageExtras(module: IModuleDefinition, pkg: IModuleDefinition | undefined): IModuleDefinition {
  if (!pkg || pkg === module) return module;
  const types = new Map(pkg.recordTypes.map((r) => [r.key, r]));
  return {
    ...module,
    recordTypes: module.recordTypes.map((rt) => {
      const own = types.get(rt.key);
      if (!own) return rt;
      return { ...rt, subTable: rt.subTable ?? own.subTable, fields: rt.fields.map((f) => withVisibility(f, own)), related: rt.related.map((r) => withFilter(r, own)) };
    }),
  };
}
